import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import inputRules from './plugins/inputRules';
import router from './routes';
import Vuex from 'vuex';
import i18n from './i18n';
import Vuelidate from 'vuelidate';
import store from './store';
import VueTabulator from 'vue-tabulator';
import Tawk from 'vue-tawk';
import { formatDateForHumans, getAge, getRangeDate, getDateTitle } from './helpers/date-helper'
import { addOrdinalSuffix } from './helpers/ordinal-suffix'
import { isValidUrl, age18Calculate } from './helpers/general'
import AsyncComputed from 'vue-async-computed'
import inputFormatter from './plugins/inputFormatter';
import DatePickerHelper from './helpers/date-picker-helper';

import './assets/fonts/fonts.css';

Vue.use(AsyncComputed)

Vue.use(Vuex);
Vue.use(Vuelidate);
Vue.use(VueTabulator);
Vue.use(inputRules);
Vue.use(inputFormatter);
Vue.use(DatePickerHelper);
Vue.config.productionTip = false;
Vue.use(Tawk, {
    tawkSrc: 'https://embed.tawk.to/616072ea157d100a41ab765d/1fhgc1oou'
});
Vue.filter('formatDateForHumans', formatDateForHumans)
Vue.filter('getAge', getAge)
Vue.filter('age18Calculate',age18Calculate)
Vue.filter('addOrdinalSuffix', addOrdinalSuffix)
Vue.filter('isValidUrl', isValidUrl)
Vue.filter('getRangeDate', getRangeDate)
Vue.filter('getDateTitle', getDateTitle)
export default new Vue({
	vuetify,
	router,
	i18n,
	store,
	render: (h) => h(App),
	beforeCreate() {
		this.$store.dispatch('setEnv');
	}
}).$mount('#app');
